import React from 'react'

const ComponentDividePage = React.lazy(() => import('pages/ComponentDivide/pages/ComponentDividePage'));
const ComponentDivideAddPage = React.lazy(() => import('pages/ComponentDivide/pages/ComponentDivideAddPage'));

const ComponentDivideRoutes = [
    {
        path: '/component-divide',
        exact: true,
        name: 'Danh sách rã linh kiện',
        function: 'RS_COMPONENTDIVIDE_VIEW',
        component: ComponentDividePage,
    },
    {
        path: '/component-divide/add',
        exact: true,
        name: 'Thêm mới',
        function: 'RS_COMPONENTDIVIDE_ADD',
        component: ComponentDivideAddPage,
    },
    {
        path: '/component-divide/edit/:component_divide_id',
        exact: true,
        name: 'Chỉnh sửa',
        function: 'RS_COMPONENTDIVIDE_EDIT',
        component: ComponentDivideAddPage,
    },
    {
        path: '/component-divide/detail/:component_divide_id',
        exact: true,
        name: 'Chi tiết',
        function: 'RS_COMPONENTDIVIDE_VIEW',
        component: ComponentDivideAddPage,
    },
    {
        path: '/component-divide/add-task/:component_divide_id',
        exact: true,
        name: 'Thêm công việc',
        function: 'RS_COMPONENTDIVIDE_ADD',
        component: ComponentDivideAddPage,
    },
]

export default ComponentDivideRoutes
